import React, { forwardRef } from "react";
import { ButtonProps } from "@mui/material/Button";
import MDButtonRoot from "./MDButtonRoot";
import { MDButtonProps } from "./types";

const MDButton = forwardRef<HTMLButtonElement, MDButtonProps & Omit<ButtonProps, 'variant' | 'color'>>(
  (
    {
      color = "white",
      variant = "contained",
      size = "medium",
      circular = false,
      iconOnly = false,
      children,
      ...rest
    },
    ref
  ) => {
    // For now, we'll use a simple dark mode detection (this should be replaced with actual theme context)
    const darkMode = false; // TODO: Get this from theme context

    // Convert our custom variant to MUI Button variant
    const muiVariant: "text" | "contained" | "outlined" = variant === "gradient" ? "contained" : variant;

    return (
      <MDButtonRoot
        {...rest}
        ref={ref}
        color="primary"
        variant={muiVariant}
        size={size}
        ownerState={{ color, variant, size, circular, iconOnly, darkMode }}
      >
        {children}
      </MDButtonRoot>
    );
  }
);

MDButton.displayName = "MDButton";

export default MDButton;